export default __webpack_public_path__ + "static/118-min-min-7a97709a6de8e9b01745d75aadae3446.jpg";